// ============================================================================
// COOKIE HELPER FUNCTIONS
// ============================================================================
function setCookie(name, value, days) {
  const d = new Date();
  d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = `expires=${d.toUTCString()}`;
  document.cookie = `${name}=${encodeURIComponent(value)};${expires};path=/`;
}

function getCookie(name) {
  const cname = `${name}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    const c = ca[i].trim();
    if (c.indexOf(cname) === 0) return c.substring(cname.length);
  }
  return '';
}



document.addEventListener('DOMContentLoaded', function () {
  // Find header links pointing to #pawplan
  const pawplanLinks = document.querySelectorAll('a[href="#pawplan"]');

  pawplanLinks.forEach(link => {
    // Match your popup system
    link.setAttribute('data-popup-target', 'popup-global');

    link.addEventListener('click', function (e) {
      e.preventDefault(); // stop page jump

      // Optional hard reset before open
      if (window.hardResetPetPopup) {
        window.hardResetPetPopup();
      }

      // Let existing popup engine handle opening
      const popup = document.getElementById('popup-global');
      if (popup) {
        popup.classList.add('active');
        document.body.style.overflow = 'hidden';
      }
    });
  });
});



function updateFormProgress(currentPage, totalPages, container) {
  const progressText = container ? container.querySelector('.form-progress-text') : document.querySelector('.form-progress-text');
  if (!progressText) return;

  // Only show progress on actual form pages, not on success page
  if (currentPage < totalPages) {
    progressText.textContent = `Step ${currentPage} of ${totalPages - 1}`;
    progressText.style.display = 'block';
  } else {
    // Hide on success screen
    progressText.style.display = 'none';
  }
}

// ============================================================================
// UTILITY FUNCTIONS
// ============================================================================
function ensureOnce(el, type, handler, options) {
  if (!el) return;
  const key = `__handler_${type}`;
  if (el[key]) el.removeEventListener(type, el[key], options);
  el.addEventListener(type, handler, options);
  el[key] = handler;
}

function clearPendingCartAddition() {
  window.pendingCartAddition = {
    form: null,
    button: null,
    shouldAutoAdd: false
  };
}

function buildPetDetailsString(pet) {
  let details = `Type: ${pet.type}
Name: ${pet.name}
Breed: ${pet.breed}
Weight: ${pet.weight}kg
Birthdate: ${pet.birthdate}`;

  if (pet.address && pet.address.postcode) {
    details += `
Postcode: ${pet.address.postcode}`;
  }
  return details;
}

function findMatchingPets(petsInfo, productTitle) {
  const isCatProduct = productTitle.includes('cat');
  const isDogProduct = productTitle.includes('dog');

  return petsInfo.filter(pet => {
    if (pet.productType) {
      return (isCatProduct && pet.productType === 'cat') ||
        (isDogProduct && pet.productType === 'dog');
    }
    return (isCatProduct && pet.type === 'cat') ||
      (isDogProduct && pet.type === 'dog');
  });
}

function getProductTitle(form) {
  const productTitleElement = form.closest('.product')?.querySelector('.product__title, .product-title, h1, .product__heading') ||
    document.querySelector('.product__title, .product-title, h1, .product__heading');
  return productTitleElement?.textContent?.toLowerCase() || '';
}

// ============================================================================
// AGE AND SIZE CALCULATION FUNCTIONS
// ============================================================================
function calculateAge(birthdate) {
  if (!birthdate) {
    return 0;
  }

  // Parse birthdate - handle YYYY-MM-DD format
  let birth = new Date(birthdate);

  // Check if date is valid
  if (isNaN(birth.getTime())) {
    // Try parsing as just year (e.g., "2023")
    const yearOnly = parseInt(birthdate);
    if (!isNaN(yearOnly) && yearOnly > 1900 && yearOnly <= new Date().getFullYear()) {
      // Use January 1st of that year as birthdate
      birth = new Date(yearOnly, 0, 1);
    } else {
      return 0;
    }
  }

  const today = new Date();

  // Calculate age in years more accurately
  let age = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();
  const dayDiff = today.getDate() - birth.getDate();

  // Adjust age if birthday hasn't occurred this year
  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
    age--;
  }

  const calculatedAge = Math.max(0, age);

  // Return age (can be 0 or positive)
  return calculatedAge;
}

function getAgeStage(petType, age) {
  // Normalize petType to lowercase
  const normalizedType = (petType || '').toLowerCase();

  // Validate age is a valid number
  if (isNaN(age) || age < 0) {
    return 'adult'; // Default fallback for invalid age
  }

  if (normalizedType === 'dog') {
    if (age >= 0 && age <= 1) {
      return 'puppy';
    }
    if (age > 1 && age <= 7) {
      return 'adult';
    }
    if (age > 7 && age <= 25) {
      return 'senior';
    }
  } else if (normalizedType === 'cat') {
    if (age >= 0 && age <= 1) {
      return 'kitten';
    }
    if (age > 1 && age <= 10) {
      return 'adult';
    }
    if (age > 10 && age <= 30) {
      return 'senior';
    }
  }

  return 'adult'; // Default fallback
}

function getSizeBand(weight, petType) {
  // Normalize petType to lowercase
  const normalizedType = (petType || '').toLowerCase();

  // Clean weight value - remove any units, spaces, etc.
  let weightStr = String(weight || '').trim();
  // Remove common units and non-numeric characters except decimal point
  weightStr = weightStr.replace(/[^\d.]/g, '');
  const weightNum = parseFloat(weightStr);

  if (isNaN(weightNum) || weightNum <= 0) {
    return normalizedType === 'cat' ? '<= 4kg' : '<= 4kg'; // Default fallback
  }

  // Cats only have 2 size bands: <= 4kg and >4kg
  if (normalizedType === 'cat') {
    const band = weightNum <= 4 ? '<= 4kg' : '>4kg';
    return band;
  }

  // Dogs have 4 size bands
  let band;
  if (weightNum <= 4) {
    band = '<= 4kg';
  } else if (weightNum > 4 && weightNum <= 10) {
    band = '4-10kg';
  } else if (weightNum > 10 && weightNum < 25) {  // Changed <= to < to make 25kg fall into >25kg band
    band = '10-25kg';
  } else {
    band = '>25kg';
  }

  return band;
}

// ============================================================================
// HIGH RISK POSTCODES (Global)
// ============================================================================
const highRiskPostcodes = [
  { postcode: '2600', state: 'ACT' },
  { postcode: '2601', state: 'ACT' },
  { postcode: '2602', state: 'ACT' },
  { postcode: '2603', state: 'ACT' },
  { postcode: '2604', state: 'ACT' },
  { postcode: '2605', state: 'ACT' },
  { postcode: '2606', state: 'ACT' },
  { postcode: '2607', state: 'ACT' },
  { postcode: '2608', state: 'ACT' },
  { postcode: '2609', state: 'ACT' },
  { postcode: '2610', state: 'ACT' },
  { postcode: '2611', state: 'ACT' },
  { postcode: '2612', state: 'ACT' },
  { postcode: '2613', state: 'ACT' },
  { postcode: '2614', state: 'ACT' },
  { postcode: '2615', state: 'ACT' },
  { postcode: '2000', state: 'NSW' },
  { postcode: '2001', state: 'NSW' },
  { postcode: '2002', state: 'NSW' },
  { postcode: '2003', state: 'NSW' },
  { postcode: '2004', state: 'NSW' },
  { postcode: '2005', state: 'NSW' },
  { postcode: '2006', state: 'NSW' },
  { postcode: '2007', state: 'NSW' },
  { postcode: '2008', state: 'NSW' },
  { postcode: '2009', state: 'NSW' },
  { postcode: '2010', state: 'NSW' },
  { postcode: '2011', state: 'NSW' },
  { postcode: '2012', state: 'NSW' },
  { postcode: '2013', state: 'NSW' },
  { postcode: '2014', state: 'NSW' },
  { postcode: '2015', state: 'NSW' },
  { postcode: '2016', state: 'NSW' },
  { postcode: '2017', state: 'NSW' },
  { postcode: '2018', state: 'NSW' },
  { postcode: '2019', state: 'NSW' },
  { postcode: '2020', state: 'NSW' },
  { postcode: '2021', state: 'NSW' },
  { postcode: '2022', state: 'NSW' },
  { postcode: '2023', state: 'NSW' },
  { postcode: '2024', state: 'NSW' },
  { postcode: '2025', state: 'NSW' },
  { postcode: '2026', state: 'NSW' },
  { postcode: '2027', state: 'NSW' },
  { postcode: '2028', state: 'NSW' },
  { postcode: '2029', state: 'NSW' },
  { postcode: '2030', state: 'NSW' },
  { postcode: '2031', state: 'NSW' },
  { postcode: '2031', state: 'NSW' },
  { postcode: '2032', state: 'NSW' },
  { postcode: '2033', state: 'NSW' },
  { postcode: '2034', state: 'NSW' },
  { postcode: '2035', state: 'NSW' },
  { postcode: '2036', state: 'NSW' },
  { postcode: '2037', state: 'NSW' },
  { postcode: '2038', state: 'NSW' },
  { postcode: '2039', state: 'NSW' },
  { postcode: '2040', state: 'NSW' },
  { postcode: '2041', state: 'NSW' },
  { postcode: '2042', state: 'NSW' },
  { postcode: '2043', state: 'NSW' },
  { postcode: '2044', state: 'NSW' },
  { postcode: '2045', state: 'NSW' },
  { postcode: '2046', state: 'NSW' },
  { postcode: '2047', state: 'NSW' },
  { postcode: '2048', state: 'NSW' },
  { postcode: '2049', state: 'NSW' },
  { postcode: '2050', state: 'NSW' },
  { postcode: '2051', state: 'NSW' },
  { postcode: '2052', state: 'NSW' },
  { postcode: '2053', state: 'NSW' },
  { postcode: '2054', state: 'NSW' },
  { postcode: '2055', state: 'NSW' },
  { postcode: '2056', state: 'NSW' },
  { postcode: '2057', state: 'NSW' },
  { postcode: '2058', state: 'NSW' },
  { postcode: '2059', state: 'NSW' },
  { postcode: '2060', state: 'NSW' },
  { postcode: '2061', state: 'NSW' },
  { postcode: '2062', state: 'NSW' },
  { postcode: '2063', state: 'NSW' },
  { postcode: '2064', state: 'NSW' },
  { postcode: '2065', state: 'NSW' },
  { postcode: '2065', state: 'NSW' },
  { postcode: '2066', state: 'NSW' },
  { postcode: '2066', state: 'NSW' },
  { postcode: '2067', state: 'NSW' },
  { postcode: '2068', state: 'NSW' },
  { postcode: '2069', state: 'NSW' },
  { postcode: '2070', state: 'NSW' },
  { postcode: '2071', state: 'NSW' },
  { postcode: '2072', state: 'NSW' },
  { postcode: '2073', state: 'NSW' },
  { postcode: '2074', state: 'NSW' },
  { postcode: '2074', state: 'NSW' },
  { postcode: '2075', state: 'NSW' },
  { postcode: '2075', state: 'NSW' },
  { postcode: '2076', state: 'NSW' },
  { postcode: '2076', state: 'NSW' },
  { postcode: '2077', state: 'NSW' },
  { postcode: '2078', state: 'NSW' },
  { postcode: '2079', state: 'NSW' },
  { postcode: '2080', state: 'NSW' },
  { postcode: '2081', state: 'NSW' },
  { postcode: '2082', state: 'NSW' },
  { postcode: '2083', state: 'NSW' },
  { postcode: '2084', state: 'NSW' },
  { postcode: '2085', state: 'NSW' },
  { postcode: '2085', state: 'NSW' },
  { postcode: '2086', state: 'NSW' },
  { postcode: '2086', state: 'NSW' },
  { postcode: '2087', state: 'NSW' },
  { postcode: '2088', state: 'NSW' },
  { postcode: '2088', state: 'NSW' },
  { postcode: '2089', state: 'NSW' },
  { postcode: '2090', state: 'NSW' },
  { postcode: '2091', state: 'NSW' },
  { postcode: '2092', state: 'NSW' },
  { postcode: '2093', state: 'NSW' },
  { postcode: '2094', state: 'NSW' },
  { postcode: '2095', state: 'NSW' },
  { postcode: '2096', state: 'NSW' },
  { postcode: '2097', state: 'NSW' },
  { postcode: '2098', state: 'NSW' },
  { postcode: '2099', state: 'NSW' },
  { postcode: '2100', state: 'NSW' },
  { postcode: '2101', state: 'NSW' },
  { postcode: '2101', state: 'NSW' },
  { postcode: '2102', state: 'NSW' },
  { postcode: '2103', state: 'NSW' },
  { postcode: '2104', state: 'NSW' },
  { postcode: '2105', state: 'NSW' },
  { postcode: '2106', state: 'NSW' },
  { postcode: '2107', state: 'NSW' },
  { postcode: '2108', state: 'NSW' },
  { postcode: '2109', state: 'NSW' },
  { postcode: '2110', state: 'NSW' },
  { postcode: '2111', state: 'NSW' },
  { postcode: '2112', state: 'NSW' },
  { postcode: '2113', state: 'NSW' },
  { postcode: '2220', state: 'NSW' },
  { postcode: '2221', state: 'NSW' },
  { postcode: '2222', state: 'NSW' },
  { postcode: '2223', state: 'NSW' },
  { postcode: '2224', state: 'NSW' },
  { postcode: '2225', state: 'NSW' },
  { postcode: '2226', state: 'NSW' },
  { postcode: '2227', state: 'NSW' },
  { postcode: '2228', state: 'NSW' },
  { postcode: '2229', state: 'NSW' },
  { postcode: '2230', state: 'NSW' },
  { postcode: '2231', state: 'NSW' },
  { postcode: '2232', state: 'NSW' },
  { postcode: '2233', state: 'NSW' },
  { postcode: '2234', state: 'NSW' },
  { postcode: '2250', state: 'NSW' },
  { postcode: '2250', state: 'NSW' },
  { postcode: '2251', state: 'NSW' },
  { postcode: '2252', state: 'NSW' },
  { postcode: '2253', state: 'NSW' },
  { postcode: '2254', state: 'NSW' },
  { postcode: '2255', state: 'NSW' },
  { postcode: '2256', state: 'NSW' },
  { postcode: '2257', state: 'NSW' },
  { postcode: '2258', state: 'NSW' },
  { postcode: '2259', state: 'NSW' },
  { postcode: '2260', state: 'NSW' },
  { postcode: '2261', state: 'NSW' },
  { postcode: '2262', state: 'NSW' },
  { postcode: '2263', state: 'NSW' },
  { postcode: '2280', state: 'NSW' },
  { postcode: '2281', state: 'NSW' },
  { postcode: '2282', state: 'NSW' },
  { postcode: '2283', state: 'NSW' },
  { postcode: '2284', state: 'NSW' },
  { postcode: '2285', state: 'NSW' },
  { postcode: '2286', state: 'NSW' },
  { postcode: '2287', state: 'NSW' },
  { postcode: '2288', state: 'NSW' },
  { postcode: '2289', state: 'NSW' },
  { postcode: '2290', state: 'NSW' },
  { postcode: '2291', state: 'NSW' },
  { postcode: '2292', state: 'NSW' },
  { postcode: '2293', state: 'NSW' },
  { postcode: '2294', state: 'NSW' },
  { postcode: '2295', state: 'NSW' },
  { postcode: '2296', state: 'NSW' },
  { postcode: '2297', state: 'NSW' },
  { postcode: '2298', state: 'NSW' },
  { postcode: '2299', state: 'NSW' },
  { postcode: '2300', state: 'NSW' },
  { postcode: '2301', state: 'NSW' },
  { postcode: '2302', state: 'NSW' },
  { postcode: '2303', state: 'NSW' },
  { postcode: '2304', state: 'NSW' },
  { postcode: '2305', state: 'NSW' },
  { postcode: '2306', state: 'NSW' },
  { postcode: '2307', state: 'NSW' },
  { postcode: '2308', state: 'NSW' },
  { postcode: '2315', state: 'NSW' },
  { postcode: '2316', state: 'NSW' },
  { postcode: '2317', state: 'NSW' },
  { postcode: '2318', state: 'NSW' },
  { postcode: '2319', state: 'NSW' },
  { postcode: '2428', state: 'NSW' },
  { postcode: '2429', state: 'NSW' },
  { postcode: '2430', state: 'NSW' },
  { postcode: '2431', state: 'NSW' },
  { postcode: '2444', state: 'NSW' },
  { postcode: '2445', state: 'NSW' },
  { postcode: '2446', state: 'NSW' },
  { postcode: '2447', state: 'NSW' },
  { postcode: '2448', state: 'NSW' },
  { postcode: '2449', state: 'NSW' },
  { postcode: '2450', state: 'NSW' },
  { postcode: '2451', state: 'NSW' },
  { postcode: '2452', state: 'NSW' },
  { postcode: '2453', state: 'NSW' },
  { postcode: '2454', state: 'NSW' },
  { postcode: '2455', state: 'NSW' },
  { postcode: '2456', state: 'NSW' },
  { postcode: '2477', state: 'NSW' },
  { postcode: '2478', state: 'NSW' },
  { postcode: '2479', state: 'NSW' },
  { postcode: '2480', state: 'NSW' },
  { postcode: '2481', state: 'NSW' },
  { postcode: '2482', state: 'NSW' },
  { postcode: '2483', state: 'NSW' },
  { postcode: '2484', state: 'NSW' },
  { postcode: '2485', state: 'NSW' },
  { postcode: '2486', state: 'NSW' },
  { postcode: '2487', state: 'NSW' },
  { postcode: '2500', state: 'NSW' },
  { postcode: '2501', state: 'NSW' },
  { postcode: '2502', state: 'NSW' },
  { postcode: '2503', state: 'NSW' },
  { postcode: '2504', state: 'NSW' },
  { postcode: '2505', state: 'NSW' },
  { postcode: '2506', state: 'NSW' },
  { postcode: '2507', state: 'NSW' },
  { postcode: '2508', state: 'NSW' },
  { postcode: '2509', state: 'NSW' },
  { postcode: '2510', state: 'NSW' },
  { postcode: '2511', state: 'NSW' },
  { postcode: '2512', state: 'NSW' },
  { postcode: '2513', state: 'NSW' },
  { postcode: '2514', state: 'NSW' },
  { postcode: '2515', state: 'NSW' },
  { postcode: '2516', state: 'NSW' },
  { postcode: '2517', state: 'NSW' },
  { postcode: '2518', state: 'NSW' },
  { postcode: '2519', state: 'NSW' },
  { postcode: '2520', state: 'NSW' },
  { postcode: '2521', state: 'NSW' },
  { postcode: '2522', state: 'NSW' },
  { postcode: '2523', state: 'NSW' },
  { postcode: '2524', state: 'NSW' },
  { postcode: '2525', state: 'NSW' },
  { postcode: '2526', state: 'NSW' },
  { postcode: '2527', state: 'NSW' },
  { postcode: '2528', state: 'NSW' },
  { postcode: '2529', state: 'NSW' },
  { postcode: '2530', state: 'NSW' },
  { postcode: '2535', state: 'NSW' },
  { postcode: '2536', state: 'NSW' },
  { postcode: '2537', state: 'NSW' },
  { postcode: '2538', state: 'NSW' },
  { postcode: '2539', state: 'NSW' },
  { postcode: '2540', state: 'NSW' },
  { postcode: '2540', state: 'NSW' },
  { postcode: '2541', state: 'NSW' },
  { postcode: '2542', state: 'NSW' },
  { postcode: '2543', state: 'NSW' },
  { postcode: '2544', state: 'NSW' },
  { postcode: '2545', state: 'NSW' },
  { postcode: '2546', state: 'NSW' },
  { postcode: '2547', state: 'NSW' },
  { postcode: '2548', state: 'NSW' },
  { postcode: '2549', state: 'NSW' },
  { postcode: '2550', state: 'NSW' },
  { postcode: '2551', state: 'NSW' },
  { postcode: '2761', state: 'NSW' },
  { postcode: '4069', state: 'QLD' },
  { postcode: '4207', state: 'QLD' },
  { postcode: '4208', state: 'QLD' },
  { postcode: '4209', state: 'QLD' },
  { postcode: '4210', state: 'QLD' },
  { postcode: '4211', state: 'QLD' },
  { postcode: '4212', state: 'QLD' },
  { postcode: '4213', state: 'QLD' },
  { postcode: '4214', state: 'QLD' },
  { postcode: '4215', state: 'QLD' },
  { postcode: '4216', state: 'QLD' },
  { postcode: '4217', state: 'QLD' },
  { postcode: '4218', state: 'QLD' },
  { postcode: '4219', state: 'QLD' },
  { postcode: '4220', state: 'QLD' },
  { postcode: '4221', state: 'QLD' },
  { postcode: '4222', state: 'QLD' },
  { postcode: '4223', state: 'QLD' },
  { postcode: '4224', state: 'QLD' },
  { postcode: '4225', state: 'QLD' },
  { postcode: '4226', state: 'QLD' },
  { postcode: '4227', state: 'QLD' },
  { postcode: '4350', state: 'QLD' },
  { postcode: '4550', state: 'QLD' },
  { postcode: '4551', state: 'QLD' },
  { postcode: '4552', state: 'QLD' },
  { postcode: '4553', state: 'QLD' },
  { postcode: '4554', state: 'QLD' },
  { postcode: '4555', state: 'QLD' },
  { postcode: '4556', state: 'QLD' },
  { postcode: '4557', state: 'QLD' },
  { postcode: '4558', state: 'QLD' },
  { postcode: '4559', state: 'QLD' },
  { postcode: '4560', state: 'QLD' },
  { postcode: '4561', state: 'QLD' },
  { postcode: '4562', state: 'QLD' },
  { postcode: '4563', state: 'QLD' },
  { postcode: '4564', state: 'QLD' },
  { postcode: '4565', state: 'QLD' },
  { postcode: '4565', state: 'QLD' },
  { postcode: '4566', state: 'QLD' },
  { postcode: '4566', state: 'QLD' },
  { postcode: '4567', state: 'QLD' },
  { postcode: '4567', state: 'QLD' },
  { postcode: '4568', state: 'QLD' },
  { postcode: '4568', state: 'QLD' },
  { postcode: '4569', state: 'QLD' },
  { postcode: '4569', state: 'QLD' },
  { postcode: '4570', state: 'QLD' },
  { postcode: '4571', state: 'QLD' },
  { postcode: '4572', state: 'QLD' },
  { postcode: '4573', state: 'QLD' },
  { postcode: '4574', state: 'QLD' },
  { postcode: '4575', state: 'QLD' },
  { postcode: '4655', state: 'QLD' },
  { postcode: '4656', state: 'QLD' },
  { postcode: '4657', state: 'QLD' },
  { postcode: '4670', state: 'QLD' },
  { postcode: '4671', state: 'QLD' },
  { postcode: '4672', state: 'QLD' },
  { postcode: '4673', state: 'QLD' },
  { postcode: '4674', state: 'QLD' },
  { postcode: '4675', state: 'QLD' },
  { postcode: '4676', state: 'QLD' },
  { postcode: '4677', state: 'QLD' },
  { postcode: '7000', state: 'TAS' },
  { postcode: '7001', state: 'TAS' },
  { postcode: '7002', state: 'TAS' },
  { postcode: '7003', state: 'TAS' },
  { postcode: '7004', state: 'TAS' },
  { postcode: '7005', state: 'TAS' },
  { postcode: '7006', state: 'TAS' },
  { postcode: '7007', state: 'TAS' },
  { postcode: '7008', state: 'TAS' },
  { postcode: '7009', state: 'TAS' },
  { postcode: '7010', state: 'TAS' },
  { postcode: '7011', state: 'TAS' },
  { postcode: '7012', state: 'TAS' },
  { postcode: '7013', state: 'TAS' },
  { postcode: '7014', state: 'TAS' },
  { postcode: '7015', state: 'TAS' },
  { postcode: '7016', state: 'TAS' },
  { postcode: '7017', state: 'TAS' },
  { postcode: '7018', state: 'TAS' },
  { postcode: '7019', state: 'TAS' },
  { postcode: '7020', state: 'TAS' },
  { postcode: '7021', state: 'TAS' },
  { postcode: '7022', state: 'TAS' },
  { postcode: '7023', state: 'TAS' },
  { postcode: '7024', state: 'TAS' },
  { postcode: '7025', state: 'TAS' },
  { postcode: '7026', state: 'TAS' },
  { postcode: '7027', state: 'TAS' },
  { postcode: '7028', state: 'TAS' },
  { postcode: '7029', state: 'TAS' },
  { postcode: '7030', state: 'TAS' },
  { postcode: '7031', state: 'TAS' },
  { postcode: '7032', state: 'TAS' },
  { postcode: '7033', state: 'TAS' },
  { postcode: '7034', state: 'TAS' },
  { postcode: '7035', state: 'TAS' },
  { postcode: '7036', state: 'TAS' },
  { postcode: '7037', state: 'TAS' },
  { postcode: '7038', state: 'TAS' },
  { postcode: '7039', state: 'TAS' },
  { postcode: '7040', state: 'TAS' },
  { postcode: '7041', state: 'TAS' },
  { postcode: '7042', state: 'TAS' },
  { postcode: '7043', state: 'TAS' },
  { postcode: '7044', state: 'TAS' },
  { postcode: '7045', state: 'TAS' },
  { postcode: '7046', state: 'TAS' },
  { postcode: '7047', state: 'TAS' },
  { postcode: '7048', state: 'TAS' },
  { postcode: '7049', state: 'TAS' },
  { postcode: '7050', state: 'TAS' },
  { postcode: '7051', state: 'TAS' },
  { postcode: '7052', state: 'TAS' },
  { postcode: '7053', state: 'TAS' },
  { postcode: '7054', state: 'TAS' },
  { postcode: '7215', state: 'TAS' },
  { postcode: '7216', state: 'TAS' },
  { postcode: '7250', state: 'TAS' },
  { postcode: '7251', state: 'TAS' },
  { postcode: '7252', state: 'TAS' },
  { postcode: '7253', state: 'TAS' },
  { postcode: '3002', state: 'VIC' },
  { postcode: '3016', state: 'VIC' },
  { postcode: '3029', state: 'VIC' },
  { postcode: '3039', state: 'VIC' },
  { postcode: '3437', state: 'VIC' },
  { postcode: '3441', state: 'VIC' },
  { postcode: '3763', state: 'VIC' },
  { postcode: '3765', state: 'VIC' },
  { postcode: '3766', state: 'VIC' },
  { postcode: '3767', state: 'VIC' },
  { postcode: '3768', state: 'VIC' },
  { postcode: '3769', state: 'VIC' },
  { postcode: '3770', state: 'VIC' },
  { postcode: '3771', state: 'VIC' },
  { postcode: '3772', state: 'VIC' },
  { postcode: '3773', state: 'VIC' },
  { postcode: '3774', state: 'VIC' },
  { postcode: '3775', state: 'VIC' },
  { postcode: '3776', state: 'VIC' },
  { postcode: '3777', state: 'VIC' },
  { postcode: '3777', state: 'VIC' },
  { postcode: '3778', state: 'VIC' },
  { postcode: '3779', state: 'VIC' },
  { postcode: '3780', state: 'VIC' },
  { postcode: '3781', state: 'VIC' },
  { postcode: '3782', state: 'VIC' },
  { postcode: '3783', state: 'VIC' },
  { postcode: '3784', state: 'VIC' },
  { postcode: '3785', state: 'VIC' },
  { postcode: '3786', state: 'VIC' },
  { postcode: '3787', state: 'VIC' },
  { postcode: '3788', state: 'VIC' },
  { postcode: '3875', state: 'VIC' },
  { postcode: '3876', state: 'VIC' },
  { postcode: '3877', state: 'VIC' },
  { postcode: '3878', state: 'VIC' },
  { postcode: '3879', state: 'VIC' },
  { postcode: '3880', state: 'VIC' },
  { postcode: '3881', state: 'VIC' },
  { postcode: '3882', state: 'VIC' },
  { postcode: '3883', state: 'VIC' },
  { postcode: '3884', state: 'VIC' },
  { postcode: '3885', state: 'VIC' },
  { postcode: '3886', state: 'VIC' },
  { postcode: '3887', state: 'VIC' },
  { postcode: '3888', state: 'VIC' },
  { postcode: '3889', state: 'VIC' },
  { postcode: '3890', state: 'VIC' },
  { postcode: '3891', state: 'VIC' },
  { postcode: '3892', state: 'VIC' },
  { postcode: '3893', state: 'VIC' },
  { postcode: '3894', state: 'VIC' },
  { postcode: '3895', state: 'VIC' },
  { postcode: '3896', state: 'VIC' },
  { postcode: '3897', state: 'VIC' },
  { postcode: '3898', state: 'VIC' },
  { postcode: '3899', state: 'VIC' },
  { postcode: '3900', state: 'VIC' },
  { postcode: '3901', state: 'VIC' },
  { postcode: '3902', state: 'VIC' },
  { postcode: '3903', state: 'VIC' },
  { postcode: '3904', state: 'VIC' },
  { postcode: '3905', state: 'VIC' },
  { postcode: '3906', state: 'VIC' },
  { postcode: '3907', state: 'VIC' },
  { postcode: '3908', state: 'VIC' },
  { postcode: '3909', state: 'VIC' },
  { postcode: '3910', state: 'VIC' },
  { postcode: '3911', state: 'VIC' },
  { postcode: '3912', state: 'VIC' },
  { postcode: '3913', state: 'VIC' },
  { postcode: '3914', state: 'VIC' },
  { postcode: '3915', state: 'VIC' },
  { postcode: '3916', state: 'VIC' },
  { postcode: '3917', state: 'VIC' },
  { postcode: '3918', state: 'VIC' },
  { postcode: '3919', state: 'VIC' },
  { postcode: '3920', state: 'VIC' },
  { postcode: '3921', state: 'VIC' },
  { postcode: '3922', state: 'VIC' },
  { postcode: '3922', state: 'VIC' },
  { postcode: '3923', state: 'VIC' },
  { postcode: '3923', state: 'VIC' },
  { postcode: '3924', state: 'VIC' },
  { postcode: '3924', state: 'VIC' },
  { postcode: '3925', state: 'VIC' },
  { postcode: '3925', state: 'VIC' },
  { postcode: '3926', state: 'VIC' },
  { postcode: '3926', state: 'VIC' },
  { postcode: '3927', state: 'VIC' },
  { postcode: '3927', state: 'VIC' },
  { postcode: '3928', state: 'VIC' },
  { postcode: '3928', state: 'VIC' },
  { postcode: '3929', state: 'VIC' },
  { postcode: '3929', state: 'VIC' },
  { postcode: '3930', state: 'VIC' },
  { postcode: '3930', state: 'VIC' },
  { postcode: '3931', state: 'VIC' },
  { postcode: '3931', state: 'VIC' },
  { postcode: '3932', state: 'VIC' },
  { postcode: '3932', state: 'VIC' },
  { postcode: '3933', state: 'VIC' },
  { postcode: '3933', state: 'VIC' },
  { postcode: '3934', state: 'VIC' },
  { postcode: '3934', state: 'VIC' },
  { postcode: '3935', state: 'VIC' },
  { postcode: '3935', state: 'VIC' },
  { postcode: '3936', state: 'VIC' },
  { postcode: '3936', state: 'VIC' },
  { postcode: '3937', state: 'VIC' },
  { postcode: '3937', state: 'VIC' },
  { postcode: '3938', state: 'VIC' },
  { postcode: '3938', state: 'VIC' },
  { postcode: '3939', state: 'VIC' },
  { postcode: '3939', state: 'VIC' },
  { postcode: '3940', state: 'VIC' },
  { postcode: '3940', state: 'VIC' },
  { postcode: '3941', state: 'VIC' },
  { postcode: '3941', state: 'VIC' },
  { postcode: '3942', state: 'VIC' },
  { postcode: '3942', state: 'VIC' },
  { postcode: '3943', state: 'VIC' },
  { postcode: '3943', state: 'VIC' },
  { postcode: '3944', state: 'VIC' },
  { postcode: '3944', state: 'VIC' },
  { postcode: '3945', state: 'VIC' },
  { postcode: '3946', state: 'VIC' },
  { postcode: '3947', state: 'VIC' },
  { postcode: '3948', state: 'VIC' },
  { postcode: '3949', state: 'VIC' },
  { postcode: '3950', state: 'VIC' },
  { postcode: '3951', state: 'VIC' },
  { postcode: '3952', state: 'VIC' },
  { postcode: '3953', state: 'VIC' },
  { postcode: '3954', state: 'VIC' },
  { postcode: '3955', state: 'VIC' },
  { postcode: '3956', state: 'VIC' },
  { postcode: '3957', state: 'VIC' },
  { postcode: '3958', state: 'VIC' },
  { postcode: '3959', state: 'VIC' },
  { postcode: '3960', state: 'VIC' },
  { postcode: '3961', state: 'VIC' },
  { postcode: '3962', state: 'VIC' },
  { postcode: '3963', state: 'VIC' },
  { postcode: '3964', state: 'VIC' },
  { postcode: '3965', state: 'VIC' },
  { postcode: '3966', state: 'VIC' },
  { postcode: '3967', state: 'VIC' },
  { postcode: '3968', state: 'VIC' },
  { postcode: '3969', state: 'VIC' },
  { postcode: '3970', state: 'VIC' },
  { postcode: '3971', state: 'VIC' },
  { postcode: '3972', state: 'VIC' },
  { postcode: '3973', state: 'VIC' },
  { postcode: '3974', state: 'VIC' },
  { postcode: '3975', state: 'VIC' },
  { postcode: '3976', state: 'VIC' },
  { postcode: '3977', state: 'VIC' },
  { postcode: '3978', state: 'VIC' },
  { postcode: '3979', state: 'VIC' },
  { postcode: '3980', state: 'VIC' },
  { postcode: '3981', state: 'VIC' },
  { postcode: '3982', state: 'VIC' },
  { postcode: '3983', state: 'VIC' },
  { postcode: '3984', state: 'VIC' },
  { postcode: '3985', state: 'VIC' },
  { postcode: '3986', state: 'VIC' },
  { postcode: '3987', state: 'VIC' },
  { postcode: '3988', state: 'VIC' },
  { postcode: '3989', state: 'VIC' },
  { postcode: '3990', state: 'VIC' },
  { postcode: '3991', state: 'VIC' },
  { postcode: '3992', state: 'VIC' },
  { postcode: '3993', state: 'VIC' },
  { postcode: '3994', state: 'VIC' },
  { postcode: '3995', state: 'VIC' },
  { postcode: '3996', state: 'VIC' }
];

// Helper function to check if a postcode is high risk (Global)
function isHighRiskPostcode(postcode) {
  return highRiskPostcodes.some(pc => pc.postcode === String(postcode).trim());
}

// Helper function to get state for a high risk postcode (Global)
function getStateForPostcode(postcode) {
  const found = highRiskPostcodes.find(pc => pc.postcode === String(postcode).trim());
  return found ? found.state : null;
}

// Product URL mapping for each recommendation
const productUrlMap = {
  // Dog Products - Simparica TRIO
  'Simparica TRIO Yellow For Puppies (1.3-2.5kg) – 3 Pack': '/products/simparica-trio-yellow-puppy',
  'Simparica TRIO Purple For Small Dogs (2.6-5kg) – 3 Pack': '/products/simparica-trio-purple-small-dogs-2-6-5kg-3-pack',
  'Simparica TRIO Orange For Small Dogs (5.1-10kg) – 3 Pack': '/products/simparica-trio-orange-small',
  'Simparica TRIO Blue For Medium Dogs (10.1-20kg) – 3 Pack': '/products/simparica-trio-blue-medium',
  'Simparica TRIO Green For Large Dogs (20.1-40kg) – 3 Pack': '/products/simparica-trio-green-large',
  'Simparica TRIO Red For Extra Large Dogs (40.1-60kg) – 3 Pack': '/products/simparica-trio-red-xl-3pk',
  
  // Dog Products - Standard Flea Treatment
  'Flea Treatment - Xsmall - Dog': '/products/flea-treatment-xsmall-dog',
  'Flea Treatment - Small - Dog': '/products/flea-treatment-small-dog',
  'Flea Treatment - Medium - Dog': '/products/flea-treatment-medium-dog',
  'Flea Treatment - Large - Dog': '/products/flea-treatment-large-dog',
  
  // Cat Products
  'Flea Treatment - Small - Cat': '/products/flea-treatment-small-cat',
  'Flea Treatment - Medium - Cat': '/products/flea-treatment-medium-cat',
  
  // The Paw Grocer Treats
  'The Paw Grocer Freeze Dried Beef Liver 90g': '/products/paw-grocer-freeze-dried-beef-liver-90g',
  'The Paw Grocer White Freeze Dried Salmon Belly Treats 90g': '/products/paw-grocer-freeze-dried-salmon-belly-90g',
  'The Paw Grocer White Freeze Dried Chicken Neck Treats 90g': '/products/paw-grocer-freeze-dried-chicken-neck-90g',
  'The Paw Grocer White Freeze Dried Chicken Wing Tips Treats 90g': '/products/paw-grocer-freeze-dried-chicken-wing-tips-90g',
  'The Paw Grocer Black Label Freeze Dried Sardines 72g': '/products/paw-grocer-freeze-dried-sardines-72g',
  'The Paw Grocer Black Label Freeze Dried Kangaroo 72g': '/products/paw-grocer-freeze-dried-kangaroo-72g',
  
  // Other Products
  'Earth Rated 100 Dog Wipes - Unscented': '/products/earth-rated-100-dog-wipes-unscented',
  'Earth Rated Bags - Unscented (60) - 4 Rolls': '/products/earth-rated-bags-unscented-60-4-rolls',
  'Calm 30\'s': '/products/calm-30s',
  'Dental Powder 80g NEW*': '/products/dental-powder-80g-new',
  'Calm & Relax 120g NEW*': '/products/calm-relax-120g-new'
};

function getRecommendationUrl(petType, ageStage, sizeBand, postcode, weight) {
  // Normalize petType to lowercase for consistent lookup
  const normalizedType = (petType || '').toLowerCase();

  // Check if postcode is high-risk
  const isHighRisk = postcode ? isHighRiskPostcode(postcode) : false;

  // Clean weight for numeric comparison
  let safeWeight = parseFloat(String(weight).replace(/[^\d.]/g, ''));
  if (isNaN(safeWeight)) safeWeight = 0;

  // DOGS
  if (normalizedType === 'dog') {
    if (isHighRisk) {
      // HIGH RISK DOGS - Simparica TRIO products
      if (safeWeight >= 1.3 && safeWeight <= 2.5) {
        return '/products/simparica-trio-yellow-puppy';
      }
      if (safeWeight >= 2.6 && safeWeight <= 5) {
        return '/products/simparica-trio-purple-small-dogs-2-6-5kg-3-pack';
      }
      if (safeWeight >= 5.1 && safeWeight <= 10) {
        return '/products/simparica-trio-orange-small';
      }
      if (safeWeight >= 10.1 && safeWeight <= 20) {
        return '/products/simparica-trio-blue-medium';
      }
      if (safeWeight >= 20.1 && safeWeight <= 40) {
        return '/products/simparica-trio-green-large';
      }
      if (safeWeight >= 40.1 && safeWeight <= 60) {
        return '/products/simparica-trio-red-xl-3pk';
      }
      
      // Fallback for weights outside defined ranges
      if (safeWeight < 1.3) return '/products/simparica-trio-yellow-puppy';
      return '/products/simparica-trio-red-xl-3pk';
    } else {
      // LOW RISK DOGS - Standard flea treatments
      if (safeWeight < 4) {
        return '/products/flea-treatment-xsmall-dog';
      }
      if (safeWeight >= 4 && safeWeight <= 10) {
        return '/products/flea-treatment-small-dog';
      }
      if (safeWeight > 10 && safeWeight <= 25) {
        return '/products/flea-treatment-medium-dog';
      }
      if (safeWeight > 25) {
        return '/products/flea-treatment-large-dog';
      }
      
      // Default fallback
      return '/products/flea-treatment-medium-dog';
    }
  }

  // CATS (No postcode risk differentiation)
  if (normalizedType === 'cat') {
    if (safeWeight < 4) {
      return '/products/flea-treatment-small-cat';
    } else {
      return '/products/flea-treatment-medium-cat';
    }
  }

  // Default fallback
  return '/pages/recommendation-page';
}



// ============================================================================
// PET INFO MANAGEMENT
// ============================================================================
function hasPetInfo() {
  const petsInfoCookie = getCookie('pets_info');
  if (!petsInfoCookie || petsInfoCookie.trim() === '' || petsInfoCookie === '[]') {
    return false;
  }
  try {
    const petsInfo = JSON.parse(petsInfoCookie);
    return petsInfo && petsInfo.length > 0;
  } catch (e) {
    return false;
  }
}

function openPetPopup() {
  const popupOverlay = document.querySelector('.popup-overlay');
  if (popupOverlay) {
    popupOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';

    const heading = popupOverlay.querySelector('.popup-heading');
    if (heading && heading.getAttribute('data-original-text') === null) {
      heading.setAttribute('data-original-text', heading.textContent);
      setTimeout(() => {
        const originalText = heading.getAttribute('data-original-text');
        if (originalText) {
          heading.textContent = originalText;
        }
      }, 3000);
    }
  }
}

function clearAllPetInfo() {
  setCookie('pets_info', '', -1);
  setCookie('pet_info', '', -1);
  setCookie('current_pet_id', '', -1);
}

// ============================================================================
// POPUP LOGIC
// ============================================================================
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.popup-overlay').forEach(function (popupOverlay) {
    const popupId = popupOverlay.getAttribute('id');
    const popupTrigger = document.querySelector(`[data-popup-target="${popupId}"]`);
    const closeButtons = popupOverlay.querySelectorAll('[data-close-popup]');
    const pages = popupOverlay.querySelectorAll('.form-page');
    const backBtn = popupOverlay.querySelector('.form-actions .btn-back[data-action="back"]');
    const nextBtn = popupOverlay.querySelector('.form-actions .btn-next[data-action="next"]');
    const submitBtn = popupOverlay.querySelector('.form-actions .btn-continue');
    const successContinueBtn = popupOverlay.querySelector('[data-reco-button]');
    const petTypeRadios = popupOverlay.querySelectorAll('input[name="pet_type"]');
    const breedSelect = popupOverlay.querySelector('#pet-breed');
    const otherBreedInput = popupOverlay.querySelector('#other-breed');
    const petNameInput = popupOverlay.querySelector('#pet-name');
    const petBirthdateInput = popupOverlay.querySelector('#pet-birthdate');
    const petWeightInput = popupOverlay.querySelector('#pet-weight');
    const addressPostcodeInput = popupOverlay.querySelector('#address-postcode');
    const petEmailInput = popupOverlay.querySelector('#pet-email');

    let currentPage = 1;
    const totalPages = pages.length;
const dogBreeds = [
  'Australian Kelpie',
  'Australian Shepherd',
  'Beagle',
  'Border Collie',
  'Cavalier King Charles Spaniel',
  'Cavoodle',
  'Chihuahua',
  'Cocker Spaniel',
  'Dachshund',
  'English Bulldog',
  'French Bulldog',
  'German Shepherd',
  'Golden Retriever',
  'Groodle',
  'Greyhound',
  'Jack Russell Terrier',
  'Labrador Retriever',
  'Labradoodle',
  'Maltese',
  'Miniature Schnauzer',
  'Poodle (Miniature)',
  'Ridgeback',
  'Rottweiler',
  'Shih Tzu',
  'Staffordshire Bull Terrier',
  'Whippet'
];


  const catBreeds = [
  'Bengal',
  'British Shorthair',
  'Burmese',
  'Domestic Shorthair',
  'Maine Coon',
  'Persian',
  'Ragdoll',
  'Russian Blue',
  'Scottish Fold',
  'Siamese'
];


    // ========================================================================
    // POSTCODE VALIDATION
    // ========================================================================
    // Note: highRiskPostcodes array and isHighRiskPostcode function are defined globally above
    if (addressPostcodeInput) {
      addressPostcodeInput.setAttribute('pattern', '[0-9]{4}');
      addressPostcodeInput.setAttribute('title', '4-digit Australian postcode (e.g., 2000)');

      const enforcePostcode = () => {
        const v = addressPostcodeInput.value.trim();
        if (!/^\d{4}$/.test(v)) {
          addressPostcodeInput.setCustomValidity('Please enter a 4-digit Australian postcode.');
          addressPostcodeInput.classList.add('invalid-input');
        } else {
          addressPostcodeInput.setCustomValidity('');
          addressPostcodeInput.classList.remove('invalid-input');
        }
      };

      addressPostcodeInput.addEventListener('input', () => {
        addressPostcodeInput.value = addressPostcodeInput.value.replace(/\D/g, '').slice(0, 4);
        enforcePostcode();
      });
      addressPostcodeInput.addEventListener('blur', enforcePostcode);
    }

    // ========================================================================
    // BIRTHDATE VALIDATION
    // ========================================================================
    if (petBirthdateInput) {
      let userInteracted = false;

      const validateDob = () => {
        if (!userInteracted) return;
        if (!petBirthdateInput.value) {
          petBirthdateInput.setCustomValidity('Please select your pet\'s birthdate.');
          petBirthdateInput.classList.add('invalid-input');
          petBirthdateInput.classList.remove('has-value');
        } else {
          petBirthdateInput.setCustomValidity('');
          petBirthdateInput.classList.remove('invalid-input');
          petBirthdateInput.classList.add('has-value');
        }
      };

      ['input', 'change', 'blur'].forEach(evt => {
        petBirthdateInput.addEventListener(evt, () => {
          userInteracted = true;
          validateDob();
        });
      });

      const openPicker = () => {
        if (typeof petBirthdateInput.showPicker === 'function') {
          petBirthdateInput.showPicker();
        } else {
          petBirthdateInput.focus();
        }
      };

      petBirthdateInput.addEventListener('click', openPicker);
      petBirthdateInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openPicker();
        }
      });

      const calendarIcon = popupOverlay.querySelector('.date-field .calendar-icon');
      if (calendarIcon) {
        calendarIcon.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          openPicker();
        });
      }

      const today = new Date();
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      petBirthdateInput.setAttribute('max', yesterday.toISOString().split('T')[0]);
    }

    // ========================================================================
    // WEIGHT VALIDATION
    // ========================================================================
    if (petWeightInput) {
      const MIN_WEIGHT = 0.1;
      const MAX_WEIGHT = 120;

      // Only allow numbers and one decimal point
      petWeightInput.addEventListener('keypress', function(e) {
        // Allow numbers, backspace, delete, tab, etc.
        if (e.which < 32 || (e.which >= 48 && e.which <= 57)) {
          return true;
        }
        
        // Allow decimal point only if one doesn't already exist
        if (e.which === 46) {
          return !this.value.includes('.');
        }
        
        e.preventDefault();
        return false;
      });

      // Simple input handling - just validate the value
      petWeightInput.addEventListener('input', function() {
        let value = this.value;
        const cursorPos = this.selectionStart;
        
        // Remove any non-numeric characters except the first decimal point
        let newValue = '';
        let hasDecimal = false;
        
        for (let i = 0; i < value.length; i++) {
          const char = value[i];
          if (char >= '0' && char <= '9') {
            newValue += char;
          } else if (char === '.' && !hasDecimal) {
            newValue += char;
            hasDecimal = true;
          }
        }
        
        // If value starts with decimal, add leading zero
        if (newValue.startsWith('.')) {
          newValue = '0' + newValue;
        }
        
        // Update the value only if it changed
        if (newValue !== value) {
          this.value = newValue;
          // Adjust cursor position if we added a leading zero
          this.setSelectionRange(
            cursorPos + (newValue.length - value.length),
            cursorPos + (newValue.length - value.length)
          );
        }
      });

      petWeightInput.addEventListener('blur', () => {
        const num = parseFloat(petWeightInput.value);
        if (isNaN(num)) return;
        if (num < MIN_WEIGHT) petWeightInput.value = MIN_WEIGHT.toString();
        if (num > MAX_WEIGHT) petWeightInput.value = `${MAX_WEIGHT.toFixed(1)}`;
      });
    }


    // ========================================================================
    // PAGE NAVIGATION
    // ========================================================================
    // function updatePage() {
    //   pages.forEach(page => page.classList.remove('active-page'));
    //   const activePage = popupOverlay.querySelector(`[data-page="${currentPage}"]`);
    //   if (activePage) activePage.classList.add('active-page');

    //   if (currentPage === totalPages) {
    //     backBtn.style.display = 'none';
    //     nextBtn.style.display = 'none';
    //     submitBtn.style.display = 'none';
    //   } else {
    //     backBtn.style.display = currentPage > 1 ? 'block' : 'none';
    //     nextBtn.style.display = currentPage < totalPages - 1 ? 'block' : 'none';
    //     submitBtn.style.display = currentPage === totalPages - 1 ? 'block' : 'none';
    //   }
    // }

    function updatePage() {
  pages.forEach(page => page.classList.remove('active-page'));
  const activePage = popupOverlay.querySelector(`[data-page="${currentPage}"]`);
  if (activePage) activePage.classList.add('active-page');

  if (currentPage === totalPages) {
    backBtn.style.display = 'none';
    nextBtn.style.display = 'none';
    submitBtn.style.display = 'none';
  } else {
    backBtn.style.display = currentPage > 1 ? 'block' : 'none';
    nextBtn.style.display = currentPage < totalPages - 1 ? 'block' : 'none';
    // Show Submit button on the last step before success
        if (currentPage === totalPages - 1) {
          submitBtn.style.display = 'block';

          // Update button text with pet name
          let currentPetName = petNameInput ? petNameInput.value.trim() : '';
          if (!currentPetName) {
            const cookieName = getCookie('pet_name');
            if (cookieName) currentPetName = decodeURIComponent(cookieName);
          }

          if (currentPetName) {
            submitBtn.textContent = `SEE ${currentPetName.toUpperCase()}'s PLAN`;
            
            // Also update email page heading with pet name
            const emailPetNameSpan = popupOverlay.querySelector('#email-pet-name');
            if (emailPetNameSpan) {
              emailPetNameSpan.textContent = currentPetName;
            }
          } else {
            submitBtn.textContent = 'SEE PLAN';
          }
        } else {
          submitBtn.style.display = 'none';
        }
  }

  updateFormProgress(currentPage, totalPages, popupOverlay);
}


    // ========================================================================
    // VALIDATION
    // ========================================================================
    function validatePage(pageNumber) {
      const currentPageEl = popupOverlay.querySelector(`[data-page="${pageNumber}"]`);
      if (!currentPageEl) return true;

      const requiredInputs = currentPageEl.querySelectorAll('[required]');
      let isValid = true;

      requiredInputs.forEach(input => {
        if (input.name === 'pet_type') return;
        if (!input.checkValidity()) {
          isValid = false;
          input.classList.add('invalid-input');
        } else {
          input.classList.remove('invalid-input');
        }
      });

      if (pageNumber === 1) {
        const selectedPet = popupOverlay.querySelector('input[name="pet_type"]:checked');
        const petTypeWrapper = popupOverlay.querySelector('.pet-type-selector');
        const petTypeError = popupOverlay.querySelector('#pet-type-error');

        if (!selectedPet) {
          isValid = false;
          if (petTypeWrapper) petTypeWrapper.classList.add('has-error');
          if (petTypeError) {
            petTypeError.style.display = 'block';
            petTypeError.textContent = 'Please select your pet (Dog or Cat).';
          }
          petTypeRadios.forEach(r => r.classList.add('invalid-input'));
        } else {
          if (petTypeWrapper) petTypeWrapper.classList.remove('has-error');
          if (petTypeError) petTypeError.style.display = 'none';
          petTypeRadios.forEach(r => r.classList.remove('invalid-input'));
        }
      }

      if (pageNumber === 3 && breedSelect && breedSelect.value === 'Other' && otherBreedInput.value.trim() === '') {
        isValid = false;
        otherBreedInput.classList.add('invalid-input');
      } else if (otherBreedInput) {
        otherBreedInput.classList.remove('invalid-input');
      }

      return isValid;
    }

    function onNextClick() {
      if (validatePage(currentPage)) {
        currentPage++;
        updatePage();
      } else {
        const currentPageEl = popupOverlay.querySelector(`[data-page="${currentPage}"]`);
        let firstInvalid = currentPageEl?.querySelector('.invalid-input, :invalid');
        if (!firstInvalid && currentPage === 1) {
          firstInvalid = petTypeRadios[0];
        }
        if (firstInvalid) {
          if (typeof firstInvalid.reportValidity === 'function') {
            firstInvalid.reportValidity();
          }
          if (typeof firstInvalid.focus === 'function') {
            firstInvalid.focus();
          }
        } else {
          alert('Please fill out all required fields.');
        }
      }
    }

    function onBackClick() {
      if (currentPage > 1) {
        currentPage--;
        updatePage();
      }
    }

    function onSubmitClick(e) {
      e.preventDefault();

      if (!validatePage(currentPage)) {
        const currentPageEl = popupOverlay.querySelector(`[data-page="${currentPage}"]`);
        const firstInvalid = currentPageEl?.querySelector('.invalid-input, :invalid');
        if (firstInvalid && typeof firstInvalid.reportValidity === 'function') {
          firstInvalid.reportValidity();
        } else {
          alert('Please fill in all required fields.');
        }
        firstInvalid?.focus();
        return;
      }

      const petTypeRaw = popupOverlay.querySelector('input[name="pet_type"]:checked')?.value || '';
      // Normalize petType to lowercase for consistency
      const petType = petTypeRaw.toLowerCase();
      const petBreed = breedSelect.value === 'Other' ? otherBreedInput.value : breedSelect.value;

      // Ensure birthdate is stored correctly
      const birthdateValue = petBirthdateInput.value || '';
      const weightValue = petWeightInput.value || '';
      const emailValue = petEmailInput?.value || '';

      const newPetInfo = {
        type: petType,
        name: petNameInput.value,
        birthdate: birthdateValue,
        weight: weightValue,
        breed: petBreed,
        address: {
          postcode: addressPostcodeInput?.value || ''
        },
        email: emailValue,
        id: Date.now()
      };

      let existingPets = [];
      const existingPetsCookie = getCookie('pets_info');
      if (existingPetsCookie) {
        try {
          existingPets = JSON.parse(existingPetsCookie);
        } catch {
          existingPets = [];
        }
      }
      const idx = existingPets.findIndex(p => p.name === newPetInfo.name);
      if (idx > -1) {
        existingPets[idx] = newPetInfo;
      } else {
        existingPets.push(newPetInfo);
      }
      const petsInfoJson = JSON.stringify(existingPets);
      setCookie('pets_info', petsInfoJson, 30);
      setCookie('current_pet_id', newPetInfo.id, 30);


      // Also save pet name to localStorage for immediate banner update
      if (newPetInfo.name && newPetInfo.name.trim()) {
        try {
          localStorage.setItem('pawplan_pet_name', newPetInfo.name.trim());
          // Also set legacy cookie for compatibility
          setCookie('pet_name', newPetInfo.name.trim(), 365);
        } catch (e) {
          console.error('Error saving to localStorage:', e);
        }
      }

      // Dispatch custom event to update banner immediately without refresh
      if (newPetInfo.name && newPetInfo.name.trim()) {
        var petName = newPetInfo.name.trim();

        // Dispatch custom event
        document.dispatchEvent(new CustomEvent('pawplan:pet-updated', {
          detail: {
            name: petName,
            type: newPetInfo.type,
            petInfo: newPetInfo
          }
        }));

        // Also directly update banner if it exists on the page
        setTimeout(function () {
          var banner = document.getElementById('pet-top-banner');
          if (banner) {
            var nameSpan = banner.querySelector('.pet-banner__name');
            if (nameSpan) {
              nameSpan.textContent = petName;
              banner.style.display = 'block';
            }
          }
        }, 100);
      }

      if (window.pendingCartAddition && window.pendingCartAddition.shouldAutoAdd) {
        const pendingForm = window.pendingCartAddition.form;
        const pendingButton = window.pendingCartAddition.button;

        if (pendingForm) {
          addPetInfoToForm(pendingForm);
        }

        popupOverlay.classList.remove('active');
        document.body.style.overflow = '';
        currentPage = 1;
        updatePage();
        clearPendingCartAddition();

        setTimeout(() => {
          if (pendingButton) {
            pendingButton.click();
          } else if (pendingForm) {
            pendingForm.submit();
          }
        }, 300);
        return;
      }

      // Skip success page and redirect directly to recommendation URL
      popupOverlay.classList.remove('active');
      document.body.style.overflow = '';
      currentPage = 1;
      updatePage();

      // Calculate age stage and size band for redirect
      // Get fresh values from form inputs with multiple fallbacks
      const currentPetType = (popupOverlay.querySelector('input[name="pet_type"]:checked')?.value || '').toLowerCase();

      // Get birthdate with fallback
      const currentBirthdate = petBirthdateInput?.value ||
        popupOverlay.querySelector('#pet-birthdate')?.value ||
        document.querySelector('#pet-birthdate')?.value || '';

      // Get weight with multiple fallbacks to ensure we get the correct value
      const currentWeight = petWeightInput?.value ||
        popupOverlay.querySelector('#pet-weight')?.value ||
        document.querySelector('#pet-weight')?.value ||
        newPetInfo?.weight || '';

      const age = calculateAge(currentBirthdate);
      const ageStage = getAgeStage(currentPetType, age);

      // Parse weight to ensure it's numeric
      const weightForCalculation = String(currentWeight).trim().replace(/[^\d.]/g, '');
      const sizeBand = getSizeBand(weightForCalculation, currentPetType);

      // Get postcode for high-risk check
      const currentPostcode = addressPostcodeInput?.value ||
        newPetInfo?.address?.postcode ||
        popupOverlay.querySelector('#address-postcode')?.value || '';

      const recommendationUrl = getRecommendationUrl(currentPetType, ageStage, sizeBand, currentPostcode, weightForCalculation);

      // Store the calculated redirect URL in a variable that persists
      window.calculatedRedirectUrl = recommendationUrl;

      // Redirect to the new PawPlan Results bundle page
      // Extract product handle from the recommendation URL for the bundle page
      let productHandle = '';
      if (recommendationUrl && recommendationUrl.startsWith('/products/')) {
        productHandle = recommendationUrl.replace('/products/', '');
      }
      
      // Store the product handle in a cookie for the bundle page to use
      if (productHandle) {
        document.cookie = `pawplan_recommended_product=${encodeURIComponent(productHandle)};path=/;max-age=2592000`;
      }
      
      // Build the bundle results page URL with product parameter
      const bundlePageUrl = productHandle 
        ? `/pages/pawplan-results?product=${encodeURIComponent(productHandle)}`
        : '/pages/pawplan-results';
      
      // Close popup and redirect to the bundle results page
      popupOverlay.classList.remove('active');
      document.body.style.overflow = '';
      currentPage = 1;
      updatePage();
      window.location.href = bundlePageUrl;
    }

    // ========================================================================
    // BREED POPULATION
    // ========================================================================
    function populateBreeds(petType) {
      if (!breedSelect) return;
      breedSelect.innerHTML = '<option value="">Select a breed</option>';
      const breeds = petType === 'dog' ? dogBreeds : catBreeds;
      breeds.forEach(breed => {
        const option = document.createElement('option');
        option.value = breed;
        option.textContent = breed;
        breedSelect.appendChild(option);
      });
      const otherOption = document.createElement('option');
      otherOption.value = 'Other';
      otherOption.textContent = 'Other';
      breedSelect.appendChild(otherOption);
    }

    petTypeRadios.forEach(radio => {
      radio.addEventListener('change', function () {
        populateBreeds(this.value);
      });
    });

    if (breedSelect && otherBreedInput) {
      breedSelect.addEventListener('change', function () {
        if (this.value === 'Other') {
          otherBreedInput.style.display = 'block';
          otherBreedInput.setAttribute('required', 'true');
        } else {
          otherBreedInput.style.display = 'none';
          otherBreedInput.removeAttribute('required');
          otherBreedInput.value = '';
        }
      });
    }

    if (successContinueBtn) {
      successContinueBtn.addEventListener('click', function () {
        // First, try to use stored redirect URL from window variable
        if (window.calculatedRedirectUrl) {
          // Convert product URL to bundle page URL
          let productHandle = '';
          if (window.calculatedRedirectUrl.startsWith('/products/')) {
            productHandle = window.calculatedRedirectUrl.replace('/products/', '');
          }
          const bundleUrl = productHandle 
            ? `/pages/pawplan-results?product=${encodeURIComponent(productHandle)}`
            : '/pages/pawplan-results';
          window.location.href = bundleUrl;
          return;
        }

        // Fallback: Get pet info from cookie to calculate redirect URL
        const petsInfoCookie = getCookie('pets_info');
        if (petsInfoCookie) {
          try {
            const petsInfo = JSON.parse(petsInfoCookie);
            if (petsInfo && petsInfo.length > 0) {
              const latestPet = petsInfo[petsInfo.length - 1];
              const age = calculateAge(latestPet.birthdate);
              const ageStage = getAgeStage(latestPet.type, age);
              const sizeBand = getSizeBand(latestPet.weight, latestPet.type);
              const petPostcode = latestPet.address?.postcode || '';
              const recommendationUrl = getRecommendationUrl(latestPet.type, ageStage, sizeBand, petPostcode);
              
              // Convert to bundle page URL
              let productHandle = '';
              if (recommendationUrl && recommendationUrl.startsWith('/products/')) {
                productHandle = recommendationUrl.replace('/products/', '');
              }
              const bundleUrl = productHandle 
                ? `/pages/pawplan-results?product=${encodeURIComponent(productHandle)}`
                : '/pages/pawplan-results';
              window.location.href = bundleUrl;
              return;
            }
          } catch (e) {
            // Fall through to default
          }
        }
        // Default fallback if no pet info found
        window.location.href = '/pages/pawplan-results';
      });
    }

    ensureOnce(nextBtn, 'click', onNextClick);
    ensureOnce(backBtn, 'click', onBackClick);
    ensureOnce(submitBtn, 'click', onSubmitClick);

    ensureOnce(popupTrigger, 'click', () => {
      popupOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
const popupTriggers = document.querySelectorAll(
  `[data-popup-target="${popupId}"], a[href="#pawplan"]`
);

popupTriggers.forEach(trigger => {
  ensureOnce(trigger, 'click', (e) => {
    e.preventDefault();

    if (window.hardResetPetPopup) {
      window.hardResetPetPopup();
    }

    popupOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  });
});

    closeButtons.forEach(btn => {
      ensureOnce(btn, 'click', () => {
        popupOverlay.classList.remove('active');
        document.body.style.overflow = '';
        currentPage = 1;
        updatePage();
        if (window.pendingCartAddition && window.pendingCartAddition.shouldAutoAdd) {
          clearPendingCartAddition();
        }
      });
    });

    ensureOnce(popupOverlay, 'click', (e) => {
      if (e.target === popupOverlay) {
        popupOverlay.classList.remove('active');
        document.body.style.overflow = '';
        currentPage = 1;
        updatePage();
        if (window.pendingCartAddition && window.pendingCartAddition.shouldAutoAdd) {
          clearPendingCartAddition();
        }
      }
    });

    ensureOnce(document, 'keydown', (e) => {
      if (e.key === 'Escape') {
        popupOverlay.classList.remove('active');
        document.body.style.overflow = '';
        currentPage = 1;
        updatePage();
        if (window.pendingCartAddition && window.pendingCartAddition.shouldAutoAdd) {
          clearPendingCartAddition();
        }
      }
    });

    updatePage();
  });
});

// ============================================================================
// ADD TO CART INTERCEPTION
// ============================================================================
function addPetInfoToForm(form) {
  if (!hasPetInfo()) {
    window.pendingCartAddition = {
      form: form,
      button: null,
      shouldAutoAdd: true
    };
    openPetPopup();
    return false;
  }

  const petsInfoCookie = getCookie('pets_info');
  if (!petsInfoCookie) {
    return false;
  }

  let petsInfo;
  try {
    petsInfo = JSON.parse(petsInfoCookie);
  } catch (err) {
    return false;
  }

  if (!petsInfo || petsInfo.length === 0) {
    return false;
  }

  const existingInputs = form.querySelectorAll('input[name^="properties[Pet"]');
  existingInputs.forEach(input => {
    input.remove();
  });

  const productTitle = getProductTitle(form);
  const matchingPets = findMatchingPets(petsInfo, productTitle);

  if (matchingPets.length > 0) {
    const latestMatchingPet = matchingPets[matchingPets.length - 1];
    const propInput = document.createElement('input');
    propInput.type = 'hidden';
    propInput.name = 'properties[Pet Details]';
    propInput.value = buildPetDetailsString(latestMatchingPet);
    form.appendChild(propInput);
  }

  return true;
}

function interceptAddToCartButtons() {
  const addToCartButtons = document.querySelectorAll(
    'button[name="add"], button[type="submit"][class*="add"], button[id*="ProductSubmitButton"], button.product-form__submit, [data-add-to-cart]'
  );

  addToCartButtons.forEach((button) => {
    button.addEventListener('click', function (e) {
      if (!hasPetInfo()) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const form = button.closest('form') || document.querySelector('form[action*="/cart/add"]');
        window.pendingCartAddition = {
          form: form,
          button: button,
          shouldAutoAdd: true
        };
        openPetPopup();
        return false;
      }

      const form = button.closest('form');
      if (form) {
        const existingPetInputs = form.querySelectorAll('input[name^="properties[Pet"]');
        existingPetInputs.forEach(input => input.remove());

        const petsInfoCookie = getCookie('pets_info');
        if (petsInfoCookie) {
          try {
            const petsInfo = JSON.parse(petsInfoCookie);
            if (petsInfo && petsInfo.length > 0) {
              const latestPet = petsInfo[petsInfo.length - 1];
              const propInput = document.createElement('input');
              propInput.type = 'hidden';
              propInput.name = 'properties[Pet Details]';
              propInput.value = buildPetDetailsString(latestPet);
              form.appendChild(propInput);
            }
          } catch (e) {
            // Silent error handling
          }
        }
      }
    }, true);
  });
}

interceptAddToCartButtons();
window.addEventListener('load', interceptAddToCartButtons);

if (typeof MutationObserver !== 'undefined') {
  const observer = new MutationObserver(() => {
    interceptAddToCartButtons();
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

const formSelectors = [
  'form[action^="/cart/add"]',
  'form[action*="/cart/add"]',
  'form[action="/cart/add"]',
  '.product-form form',
  '[data-product-form]',
  'form[action*="cart"]',
  'form[action*="add"]'
];

formSelectors.forEach(selector => {
  const forms = document.querySelectorAll(selector);
  forms.forEach((form) => {
    ensureOnce(form, 'submit', function (e) {
      const canProceed = addPetInfoToForm(form);
      if (canProceed === false) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    });
  });
});

ensureOnce(document, 'submit', function (e) {
  const form = e.target;
  if (form && form.tagName === 'FORM') {
    if (form.action.includes('/cart/add') ||
      form.action.includes('cart') ||
      form.querySelector('input[name="add"]') ||
      form.querySelector('button[type="submit"]') ||
      form.querySelector('[data-add-to-cart]')) {
      const canProceed = addPetInfoToForm(form);
      if (canProceed === false) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    }
  }
});

window.addEventListener('load', function () {
  const allForms = document.querySelectorAll('form');
  allForms.forEach((form) => {
    if (form.action.includes('/cart/add') ||
      form.action.includes('cart') ||
      form.querySelector('input[name="add"]') ||
      form.querySelector('button[type="submit"]') ||
      form.querySelector('[data-add-to-cart]')) {
      ensureOnce(form, 'submit', handleFormSubmit);
    }
  });
});

function handleFormSubmit(e) {
  const form = e.target;

  if (!hasPetInfo()) {
    e.preventDefault();
    e.stopPropagation();
    window.pendingCartAddition = {
      form: form,
      button: null,
      shouldAutoAdd: true
    };
    openPetPopup();
    return false;
  }

  const petsInfoCookie = getCookie('pets_info');
  if (!petsInfoCookie) return;

  let petsInfo;
  try {
    petsInfo = JSON.parse(petsInfoCookie);
  } catch (err) {
    return;
  }

  if (!petsInfo || petsInfo.length === 0) return;

  const existingInputs = form.querySelectorAll('input[name^="properties[Pet"]');
  existingInputs.forEach(input => {
    input.remove();
  });

  const productTitle = getProductTitle(form);
  const matchingPets = findMatchingPets(petsInfo, productTitle);

  if (matchingPets.length > 0) {
    const latestMatchingPet = matchingPets[matchingPets.length - 1];
    const propInput = document.createElement('input');
    propInput.type = 'hidden';
    propInput.name = 'properties[Pet Details]';
    propInput.value = buildPetDetailsString(latestMatchingPet);
    form.appendChild(propInput);
  }
}

// ============================================================================
// GLOBAL EXPORTS
// ============================================================================
window.getCookie = getCookie;
window.setCookie = setCookie;
window.clearAllPetInfo = clearAllPetInfo;
window.clearPetDataFromCartItems = clearPetDataFromCartItems;

window.pendingCartAddition = {
  form: null,
  button: null,
  shouldAutoAdd: false
};

// ============================================================================
// CART MANAGEMENT FUNCTIONS
// ============================================================================
function clearPetDataFromCartItems() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      if (!cart.items || cart.items.length === 0) {
        return;
      }

      const updates = cart.items.map(item => {
        const newProperties = { ...item.properties };
        Object.keys(newProperties).forEach(key => {
          if (key.includes('Pet') || key.includes('pet')) {
            delete newProperties[key];
          }
        });
        return {
          id: item.id,
          quantity: item.quantity,
          properties: newProperties
        };
      });

      Promise.all(updates.map(u => {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: cart.items.find(i => i.id === u.id)?.key ?? undefined,
            quantity: u.quantity,
            properties: u.properties
          })
        });
      }))
        .then(() => {
          window.location.reload();
        })
        .catch(error => {
          // Silent error handling
        });
    })
    .catch(error => {
      // Silent error handling
    });
}

function deletePet(petId) {
  const petsInfoCookie = getCookie('pets_info');
  if (!petsInfoCookie) {
    return;
  }

  let petsInfo;
  try {
    petsInfo = JSON.parse(petsInfoCookie);
  } catch (err) {
    return;
  }

  const petIndex = petsInfo.findIndex(pet => pet.id == petId);
  if (petIndex === -1) {
    return;
  }

  const deletedPet = petsInfo.splice(petIndex, 1)[0];

  if (petsInfo.length > 0) {
    setCookie('pets_info', JSON.stringify(petsInfo), 30);
  } else {
    setCookie('pets_info', '', -1);
  }

  updateCartAfterPetDeletion(petsInfo);

  if (window.displayPetInfoFromCookie) {
    window.displayPetInfoFromCookie();
  } else {
    updateCartDisplayWithPetInfo(petsInfo);
  }
}

function updateCartAfterPetDeletion(remainingPets) {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      if (!cart.items || cart.items.length === 0) {
        return;
      }

      const updates = cart.items.map(item => {
        const newProperties = { ...item.properties };
        Object.keys(newProperties).forEach(key => {
          if (key.startsWith('Pet') && key.includes('Info')) {
            delete newProperties[key];
          }
        });

        if (remainingPets.length > 0) {
          const latestPet = remainingPets[remainingPets.length - 1];
          newProperties['Pet Details'] = buildPetDetailsString(latestPet);
        }

        return {
          id: item.id,
          quantity: item.quantity,
          properties: newProperties
        };
      });

      Promise.all(updates.map(u => {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: cart.items.find(i => i.id === u.id)?.key ?? undefined,
            quantity: u.quantity,
            properties: u.properties
          })
        });
      }))
        .then(() => {
          // Success - no action needed
        })
        .catch(error => {
          // Silent error handling
        });
    })
    .catch(error => {
      // Silent error handling
    });
}

function updateCartDisplayWithPetInfo(petsInfo) {
  let petsInfoHTML = '';
  if (petsInfo && petsInfo.length > 0) {
    const latestPet = petsInfo[petsInfo.length - 1];
    const petTitle = latestPet.name || 'Your Pet';
    petsInfoHTML = `
<div class="pet-info-section" data-pet-id="${latestPet.id}">
<div class="pet-info-header">
<h4 class="pet-info-title">${petTitle}</h4>
<button type="button" class="pet-delete-btn" data-pet-id="${latestPet.id}" aria-label="Delete pet ${latestPet.name}">
<span class="svg-wrapper">
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
<polyline points="3,6 5,6 21,6"></polyline>
<path d="m19,6v14a2,2 0 0,1 -2,2H7a2,2 0 0,1 -2,-2V6m3,0V4a2,2 0 0,1 2,-2h4a2,2 0 0,1 2,2v2"></path>
<line x1="10" y1="11" x2="10" y2="17"></line>
<line x1="14" y1="11" x2="14" y2="17"></line>
</svg>
</span>
</button>
</div>
<div class="pet-info-item">
<span class="pet-info-label">Type:</span>
<span class="pet-info-value">${latestPet.type || 'Not specified'}</span>
</div>
<div class="pet-info-item">
<span class="pet-info-label">Breed:</span>
<span class="pet-info-value">${latestPet.breed || 'Not specified'}</span>
</div>
<div class="pet-info-item">
<span class="pet-info-label">Weight:</span>
<span class="pet-info-value">${latestPet.weight || 'Not specified'} kg</span>
</div>
<div class="pet-info-item">
<span class="pet-info-label">Birthdate:</span>
<span class="pet-info-value">${latestPet.birthdate || 'Not specified'}</span>
</div>
</div>
`;
  }

  const cartItemPetInfoDisplays = document.querySelectorAll('.cart-item-pet-info');
  cartItemPetInfoDisplays.forEach(display => {
    const cartItemRow = display.closest('tr');
    const productTitleElement = cartItemRow?.querySelector('.cart-item__name');
    const productTitle = productTitleElement?.textContent?.toLowerCase() || '';

    if (petsInfo && petsInfo.length > 0) {
      const matchingPets = findMatchingPets(petsInfo, productTitle);

      if (matchingPets.length > 0) {
        const latestMatchingPet = matchingPets[matchingPets.length - 1];
        const petTitle = latestMatchingPet.name || 'Your Pet';
        const petInfoHTML = `
<div class="pet-info-section" data-pet-id="${latestMatchingPet.id}">
<div class="pet-info-header">
<h4 class="pet-info-title">${petTitle}</h4>
<button type="button" class="pet-delete-btn" data-pet-id="${latestMatchingPet.id}" aria-label="Delete pet ${latestMatchingPet.name}">
<span class="svg-wrapper">
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
<polyline points="3,6 5,6 21,6"></polyline>
<path d="m19,6v14a2,2 0 0,1 -2,2H7a2,2 0 0,1 -2,-2V6m3,0V4a2,2 0 0,1 2,-2h4a2,2 0 0,1 2,2v2"></path>
<line x1="10" y1="11" x2="10" y2="17"></line>
<line x1="14" y1="11" x2="14" y2="17"></line>
</svg>
</span>
</button>
</div>
<div class="pet-info-item">
<span class="pet-info-label">Type:</span>
<span class="pet-info-value">${latestMatchingPet.type || 'Not specified'}</span>
</div>
<div class="pet-info-item">
<span class="pet-info-label">Breed:</span>
<span class="pet-info-value">${latestMatchingPet.breed || 'Not specified'}</span>
</div>
<div class="pet-info-item">
<span class="pet-info-label">Weight:</span>
<span class="pet-info-value">${latestMatchingPet.weight || 'Not specified'} kg</span>
</div>
<div class="pet-info-item">
<span class="pet-info-label">Birthdate:</span>
<span class="pet-info-value">${latestMatchingPet.birthdate || 'Not specified'}</span>
</div>
</div>
`;
        display.innerHTML = petInfoHTML;
        display.style.display = 'block';

        const deleteButtons = display.querySelectorAll('.pet-delete-btn');
        deleteButtons.forEach(button => {
          button.addEventListener('click', function () {
            const petId = this.getAttribute('data-pet-id');
            deletePet(petId);
          });
        });
      } else {
        display.style.display = 'none';
        display.innerHTML = '';
      }
    } else {
      display.style.display = 'none';
      display.innerHTML = '';
    }
  });

  const cartPetInfoDisplay = document.querySelector('#pet-info-cart');
  const emptyCartPetInfoDisplay = document.querySelector('#pet-info-empty-cart');
  if (cartPetInfoDisplay) {
    cartPetInfoDisplay.style.display = 'none';
    cartPetInfoDisplay.innerHTML = '';
  }
  if (emptyCartPetInfoDisplay) {
    emptyCartPetInfoDisplay.style.display = 'none';
    emptyCartPetInfoDisplay.innerHTML = '';
  }
}

function addPetInfoToExistingCartItems(newPetInfo) {
  let allPetsInfo = [];
  const petsInfoCookie = getCookie('pets_info');
  if (petsInfoCookie) {
    try {
      allPetsInfo = JSON.parse(petsInfoCookie);
    } catch (err) {
      allPetsInfo = [newPetInfo];
    }
  } else {
    allPetsInfo = [newPetInfo];
  }

  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      if (!cart.items || cart.items.length === 0) {
        return;
      }

      const updates = cart.items.map(item => {
        const newProperties = { ...item.properties };
        Object.keys(newProperties).forEach(key => {
          if (key.startsWith('Pet') && key.includes('Info')) {
            delete newProperties[key];
          }
        });

        if (allPetsInfo.length > 0) {
          const latestPet = allPetsInfo[allPetsInfo.length - 1];
          newProperties['Pet Details'] = buildPetDetailsString(latestPet);
        }

        return {
          id: item.id,
          quantity: item.quantity,
          properties: newProperties
        };
      });

      Promise.all(updates.map(u => {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: cart.items.find(i => i.id === u.id)?.key ?? undefined,
            quantity: u.quantity,
            properties: u.properties
          })
        });
      }))
        .then(() => {
          if (window.displayPetInfoFromCookie) {
            window.displayPetInfoFromCookie();
          } else {
            updateCartDisplayWithPetInfo(allPetsInfo);
          }
        })
        .catch(error => {
          // Silent error handling
        });
    })
    .catch(error => {
      // Silent error handling
    });
}

// ============================================================================
// GLOBAL RESET FUNCTION (Added for Rebuy "Add Another Pet" button)
// ============================================================================
window.hardResetPetPopup = function() {
  const popupOverlay = document.querySelector('.popup-overlay');
  if (!popupOverlay) return;

  // 1. Reset all inputs
  const inputs = popupOverlay.querySelectorAll('input, select, textarea');
  inputs.forEach(input => {
    if (input.type === 'radio' || input.type === 'checkbox') {
      input.checked = false;
    } else {
      input.value = '';
    }
    
    // Remove individual invalid states
    input.classList.remove('invalid-input');
    input.removeAttribute('aria-invalid');
  });

  // 2. Hide conditional fields (e.g. "Other" breed)
  const otherBreedInput = document.getElementById('other-breed');
  if (otherBreedInput) {
    otherBreedInput.style.display = 'none';
    otherBreedInput.removeAttribute('required');
  }
  
  // 3. Reset Pages (Show Page 1, Hide others)
  const pages = popupOverlay.querySelectorAll('.form-page');
  pages.forEach(page => {
    page.classList.remove('active-page');
    // Ensure styles are reset if inline styles were applied
    page.style.opacity = ''; 
    page.style.pointerEvents = '';
    page.style.transform = '';
  });
  
  const page1 = popupOverlay.querySelector('.form-page[data-page="1"]');
  if (page1) {
    page1.classList.add('active-page');
  }

  // 4. Reset Button Visibility
  const btnBack = popupOverlay.querySelector('[data-action="back"]');
  const btnNext = popupOverlay.querySelector('[data-action="next"]');
  const btnSubmit = popupOverlay.querySelector('.btn-continue'); /* The actual submit button */
  
  if (btnBack) btnBack.style.display = 'none';
  if (btnNext) btnNext.style.display = ''; /* Reset to CSS default (likely inline-block or flex) */
  if (btnSubmit) btnSubmit.style.display = 'none';

  // 5. Reset Progress (if any visual indicators exist)
  // (Assuming CSS handles it via page classes, but if there's a bar:)
  const progressBar = popupOverlay.querySelector('.progress-bar');
  if (progressBar) progressBar.style.width = '0%';
};
